<div class="novo-visto-layout">
    <form [formGroup]="novoVistoForm" (ngSubmit)="onGerarSolicitacao()" class="novo-visto-form w-full">
        <div class="novo-visto-corpo">
            <aside class="coluna-filtros">
                <app-card-content [headerColor]="true" [icon]="'pi pi-calendar'" [title]="'Visto Selecionado'" [subtitle]="'Tipo de Visto Temporário'">
                    <div class="tipo-visto-grid">
                        @if (novoVistoForm.controls.tipoVisto.value === '90_CORRIDOS') {
                            <div class="tipo-visto-card selecionado" style="cursor: default">
                                <div class="tipo-visto-texto">
                                    <strong>90 Dias Corridos</strong>
                                    <small>Autorização padrão para permanência contínua.</small>
                                </div>
                            </div>
                        }

                        @if (novoVistoForm.controls.tipoVisto.value === '90_FRACIONADOS') {
                            <div class="tipo-visto-card selecionado" style="cursor: default">
                                <div class="tipo-visto-texto">
                                    <strong>90 Dias Fracionados</strong>
                                    <small>Múltiplas entradas até o limite de 90 dias.</small>
                                </div>
                            </div>
                        }
                    </div>

                    @if (isVistoFracionado()) {
                        <div class="field mt-3">
                            <label class="block mb-1">Local do Visto</label>
                            <div class="local-visto-grid">
                                @if (periodoForm.controls.localVisto.value === 'ORIGEM') {
                                    <div class="local-visto-opcao selecionado" style="cursor: default">
                                        <span>Origem</span>
                                    </div>
                                }
                                @if (periodoForm.controls.localVisto.value === 'OUTRO_CRM') {
                                    <div class="local-visto-opcao selecionado" style="cursor: default">
                                        <span>Outro CRM</span>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </app-card-content>

                <app-card-content [headerColor]="false" [icon]="'pi pi-clock'" [title]="'Período do Visto'" [subtitle]="'Visto Temporário'" [formGroup]="periodoForm">
                    <div class="card-filtros-body">
                        <div class="filtros-linha">
                            <div class="field">
                                <label class="block mb-1">Data Início</label>
                                <p-inputmask formControlName="periodoInicio" mask="99/99/9999" placeholder="DD/MM/AAAA" styleClass="w-full" (onComplete)="atualizarDataFimVistoCorrido()"></p-inputmask>
                            </div>
                            <div class="field">
                                <label class="block mb-1">Data Fim</label>
                                <p-inputmask formControlName="periodoFim" mask="99/99/9999" placeholder="DD/MM/AAAA" [readonly]="isVistoCorridos()" [styleClass]="isVistoCorridos() ? 'w-full readonly-input' : 'w-full'"></p-inputmask>
                            </div>
                        </div>

                        <div class="filtros-linha">
                            <div class="field">
                                <label class="block mb-1">{{ getRotuloUfLocalVisto() }}</label>
                                <p-select class="w-full" formControlName="ufOrigem" [options]="ufs" optionLabel="label" optionValue="value" appendTo="body"></p-select>
                            </div>
                            @if (isCrmOrigemVisivel()) {
                                <div class="field">
                                    <label class="block mb-1">CRM Origem</label>
                                    <input pInputText formControlName="crmOrigem" class="w-full" />
                                </div>
                            }
                        </div>

                        @if (isOutroCrmSelecionado()) {
                            <div class="field">
                                <label class="block mb-1">Protocolo Origem</label>
                                <input pInputText formControlName="documentoOrigem" class="w-full" inputmode="numeric" pattern="[0-9]*" (input)="onDocumentoOrigemInput()" />
                            </div>
                        }
                    </div>
                </app-card-content>
            </aside>

            <section class="coluna-conteudo">
                <app-card-content [headerColor]="false" [icon]="'pi pi-users'" [title]="'Dados das Partes'" [subtitle]="'Solicitante e Finalidade'">
                    <div class="card-filtros-body">
                        <div class="field">
                            <label class="block mb-1">Solicitante</label>
                            <div class="input-pesquisa">
                                <input pInputText formControlName="solicitante" class="w-full" placeholder="Clique no botão ao lado para pesquisar" [readonly]="true" />
                                <p-button type="button" icon="pi pi-search" styleClass="p-button-outlined botao-pesquisa" ariaLabel="Pesquisar solicitante" (onClick)="abrirPesquisaSolicitante()"></p-button>
                            </div>
                            <small class="campo-ajuda">Utilize a busca para encontrar registros existentes no sistema.</small>
                        </div>

                        @if (isRequerenteObrigatorio()) {
                            <div class="field">
                                <label class="block mb-1">Requerente</label>
                                <div class="input-pesquisa">
                                    <input pInputText formControlName="requerente" class="w-full" placeholder="Clique no botão ao lado para pesquisar" [readonly]="true" />
                                    <p-button type="button" icon="pi pi-search" styleClass="p-button-outlined botao-pesquisa" ariaLabel="Pesquisar requerente" (onClick)="abrirPesquisaRequerente()"></p-button>
                                </div>
                            </div>
                        }

                        @if (isMedicoRelacionadoObrigatorio()) {
                            <div class="field">
                                <label class="block mb-1">Médico Relacionado</label>
                                <div class="input-pesquisa">
                                    <input pInputText formControlName="medicoRelacionado" class="w-full" placeholder="Clique no botão ao lado para pesquisar" [readonly]="true" />
                                    <p-button type="button" icon="pi pi-search" styleClass="p-button-outlined botao-pesquisa" ariaLabel="Pesquisar médico relacionado" (onClick)="abrirPesquisaMedicoRelacionado()"></p-button>
                                </div>
                                <small class="campo-ajuda">O período do visto será vinculado a este médico.</small>
                            </div>
                        }

                        <div class="field">
                            <label class="block mb-1">Finalidade da Solicitação</label>
                            <textarea pTextarea rows="5" formControlName="finalidade" class="w-full" placeholder="Descreva o motivo detalhado desta solicitação..."></textarea>
                        </div>
                    </div>

                    <div class="novo-visto-acoes">
                        <p-button label="Cancelar" icon="pi pi-times" severity="secondary" type="button" [outlined]="true" (onClick)="onCancelar()"></p-button>
                        <p-button label="Gerar Solicitação" icon="pi pi-check" type="submit" [disabled]="novoVistoForm.invalid || periodoForm.invalid" [appCan]="roleVistoCriar"></p-button>
                    </div>
                </app-card-content>
            </section>
        </div>
    </form>
</div>

<app-pesquisar-pessoa-custom [(showDialog)]="mostrarPesquisaSolicitante" [tiposPessoaPermitidos]="getTiposPessoaPesquisa()" (pessoa)="onSelecionarSolicitante($event)"></app-pesquisar-pessoa-custom>

<p-dialog appDialogoPadrao="pi pi-check-square" descricao="O tipo define o prazo e os documentos exigidos." [(visible)]="exibirDialogTipoVisto" [closable]="false" [style]="{ width: '45rem' }" header="Escolha o Tipo de Visto Temporário">
    <div class="py-3">
        <p class="mb-4" style="color: var(--text-color-secondary, #4f6788); font-size: 1rem; margin-bottom: 1.5rem">Selecione o tipo de visto temporário que deseja solicitar para prosseguir com o preenchimento do formulário.</p>

        <div class="tipo-visto-grid">
            <div class="tipo-visto-card" [class.selecionado]="tipoVistoSelecionadoTemp === '90_CORRIDOS'" (click)="tipoVistoSelecionadoTemp = '90_CORRIDOS'">
                <div class="tipo-visto-texto">
                    <strong>90 Dias Corridos</strong>
                    <small>Autorização padrão para permanência contínua.</small>
                </div>
                <p-radiobutton name="tipoVistoTemp" value="90_CORRIDOS" [(ngModel)]="tipoVistoSelecionadoTemp" inputId="visto-corridos-dialog"></p-radiobutton>
            </div>

            <div class="tipo-visto-card" [class.selecionado]="tipoVistoSelecionadoTemp === '90_FRACIONADOS'" (click)="tipoVistoSelecionadoTemp = '90_FRACIONADOS'">
                <div class="tipo-visto-texto">
                    <strong>90 Dias Fracionados</strong>
                    <small>Múltiplas entradas até o limite de 90 dias.</small>
                </div>
                <p-radiobutton name="tipoVistoTemp" value="90_FRACIONADOS" [(ngModel)]="tipoVistoSelecionadoTemp" inputId="visto-fracionados-dialog"></p-radiobutton>
            </div>
        </div>

        @if (tipoVistoSelecionadoTemp === '90_FRACIONADOS') {
            <div class="dialog-section-header">
                <app-header-divisor [label]="'Local do Visto'" [icon]="'pi pi-map-marker'"></app-header-divisor>
            </div>

            <div class="local-visto-grid">
                <div class="local-visto-opcao" [class.selecionado]="localVistoSelecionadoTemp === 'ORIGEM'" (click)="localVistoSelecionadoTemp = 'ORIGEM'" style="width: 100%">
                    <p-radiobutton name="localVistoTemp" value="ORIGEM" [(ngModel)]="localVistoSelecionadoTemp" inputId="local-origem-dialog"></p-radiobutton>
                    <label for="local-origem-dialog" style="cursor: pointer; margin-left: 0.25rem; font-weight: 500">Origem</label>
                </div>
                <div class="local-visto-opcao" [class.selecionado]="localVistoSelecionadoTemp === 'OUTRO_CRM'" (click)="localVistoSelecionadoTemp = 'OUTRO_CRM'" style="width: 100%">
                    <p-radiobutton name="localVistoTemp" value="OUTRO_CRM" [(ngModel)]="localVistoSelecionadoTemp" inputId="local-outro-dialog"></p-radiobutton>
                    <label for="local-outro-dialog" style="cursor: pointer; margin-left: 0.25rem; font-weight: 500">Outro CRM</label>
                </div>
            </div>
        }

        <div class="flex justify-end gap-2" style="margin-top: 1.8rem; display: flex; justify-content: flex-end; gap: 0.75rem; border-top: 1px solid var(--surface-border, #e3e8f2); padding-top: 1.2rem">
            <p-button label="Cancelar" icon="pi pi-times" severity="secondary" [outlined]="true" (onClick)="cancelarDialogTipoVisto()"></p-button>
            <p-button label="Confirmar" icon="pi pi-check" (onClick)="confirmarDialogTipoVisto()"></p-button>
        </div>
    </div>
</p-dialog>
